import { render, staticRenderFns } from "./CopyModal.vue?vue&type=template&id=086c17a9"
import script from "./CopyModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./CopyModal.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./CopyModal.vue?vue&type=style&index=0&id=086c17a9&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports